import { reportingDashboardConstants } from '../_constants';

const {
	GET_REPORT_COUNT_START,
	GET_REPORT_COUNT_SUCCESS,
	GET_REPORT_COUNT_FAILED,
	FILTER_COUNT_START,
	FILTER_COUNT_SUCCESS,
	FILTER_COUNT_FAILED,
} = reportingDashboardConstants;

const initialState = {
	countLoading: false,
	error: false,
	countSummary: {
		successfulCount: 0,
		failedCount: 0,
		pendingCount: 0,
		unprocessedCount: 0,
	},
	filteredCountSummary: {
		successfulCount: 0,
		failedCount: 0,
		pendingCount: 0,
		unprocessedCount: 0,
	},
};

const ReportingDashboardCountReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case GET_REPORT_COUNT_START:
			return {
				...state,
				countLoading: true,
			};
		case GET_REPORT_COUNT_SUCCESS:
			const { successfulCount, failedCount, pendingCount, unprocessedCount } =
				payload;
			return {
				...state,
				countLoading: false,
				countSummary: {
					successfulCount: successfulCount,
					failedCount: failedCount,
					pendingCount: pendingCount,
					unprocessedCount: unprocessedCount,
				},
			};
		case GET_REPORT_COUNT_FAILED:
			return {
				...state,
				countLoading: false,
				error: payload,
			};
		case FILTER_COUNT_START:
			return { ...state, countLoading: true };
		case FILTER_COUNT_SUCCESS:
			const {
				successfulCount: filteredSuccessfulCount,
				failedCount: filteredFailedCount,
				pendingCount: filteredPendingCount,
				unprocessedCount: filteredUnprocessedCount,
			} = payload;
			return {
				...state,
				countLoading: false,
				filteredCountSummary: {
					successfulCount: filteredSuccessfulCount,
					failedCount: filteredFailedCount,
					pendingCount: filteredPendingCount,
					unprocessedCount: filteredUnprocessedCount,
				},
			};
		case FILTER_COUNT_FAILED:
			return {
				...state,
				countLoading: false,
				error: payload,
			};
		default:
			return state;
	}
};

export default ReportingDashboardCountReducer;
